const SocialProof: React.FC = () => {
    return (
        <section className="bg-black text-white py-12 px-4 border-t border-zinc-800">
            <div className="max-w-4xl mx-auto">
                {/* Título de la sección */}
                <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">
                    Real Results from Real People
                </h2>

                {/* Grid de pruebas */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                    {/* Review de Avery */}
                    <div className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden hover:border-cyan-400/30 transition-all">
                        <div className="p-4">
                            <h3 className="text-lg font-semibold text-cyan-400 mb-4">
                                What People Are Saying fff
                            </h3>
                            <img
                                src="/review-avery.jpeg"
                                alt="Review from Avery"
                                className="w-full h-auto rounded-md max-h-[400px] object-contain"
                            />
                        </div>
                    </div>

                    {/* Revenue de X */}
                    <div className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden hover:border-cyan-400/30 transition-all">
                        <div className="p-4">
                            <h3 className="text-lg font-semibold text-cyan-400 mb-4">
                                Real Revenue from X
                            </h3>
                            <img
                                src="/revenue-x.jpeg"
                                alt="Revenue generated from X"
                                className="w-full h-auto rounded-md max-h-[400px] object-contain"
                            />
                        </div>
                    </div>
                </div>

                {/* Texto adicional opcional */}
                <p className="text-center text-gray-400 text-sm mt-8">
                    These are just some of the results. The playbook shows you exactly how to replicate them.
                </p>
            </div>
        </section>
    );
};

export default SocialProof;
